import { createSelector, createSlice } from "@reduxjs/toolkit";

const userSlice = createSlice({
    name: 'userData',
    initialState: {
        user: null,
        token: null,
        isAuthenticated: false,
        isRunning: false,
        profile: null,
        emergency:[]
    },
    reducers: {
        login: (state, action) => {
            state.isRunning = true;
            // //console.log(action.payload)
        },
        loginSuccessful: (state, action) => {
            // //console.log(action.payload)
            state.isAuthenticated = true
            state.user = action.payload.user;
            state.token = action.payload.token;
            state.isRunning = false
        },
        logoutSuccessful: (state) => {
            state.user = null;
            state.token = null;
            state.isAuthenticated = false;
            state.isRunning = false;
            state.profile = null;
        },
        loginFailed: (state) => {
            state.user = null;
            state.token = null;
            state.isAuthenticated = false;
            state.isRunning = false;
        },
        resetPassword: (state) => {
            state.isRunning = true;
        },
        changePassword: () => { },
        forceResetPassword: () => { },
        getMyProfile: () => { },
        changeMyProfilePicture: () => { },
        updateEmergencyContact:()=>{},
        createEmergencyContact:()=>{},
        storeEmergencyContact:(state,action)=>{
            // state.emergency=[action.payload,...state.emergency];
        },
        updateMyProfile:(state,action)=>{

        },
        storeMyProfilePicture: (state,action) => {
           
         },
        storeMyProfile: (state, action) => {
            state.profile = action.payload
        }
    }
})

export const {
    login,
    loginSuccessful,
    updateMyProfile,
    createEmergencyContact,
    updateEmergencyContact,
    storeEmergencyContact,
    logoutSuccessful,
    changeMyProfilePicture,
    storeMyProfilePicture,
    loginFailed,
    resetPassword,
    changePassword,
    forceResetPassword,
    getMyProfile,
    storeMyProfile
} = userSlice.actions

export const userDetailsSelector = createSelector(
    state => state.user,
    user => user
);

export const userProfileSelector = createSelector(
    state => state.user,
    user => user.user
)


export const userTokenSelector = createSelector(
    state => state.user,
    user => user.token
);

export const userRoleSelector = createSelector(
    state => state.user,
    user => user.user.role
);
export default userSlice.reducer